import fromObjectToKeys from 'utils/converters/object/fromObjectToKeys.util';
import isFalsy from 'utils/predicates/isFalsy.util';

const isEmptyObject = (value) => {
  // not an object, testing only existing objects
  if (value === null || typeof value !== 'object') return false;

  // arrays *are* objects, but not useful in this case, testing plain objects only
  if (Array.isArray(value)) return false;

  // the object just needs to have no enumerable keys
  return isFalsy(fromObjectToKeys(value).length);
};

// noinspection JSUnusedGlobalSymbols
export default isEmptyObject;
